import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from '@mui/material';
import Button from '../../common/Button';
import ListItemText from 'components/common/ListItemText';

const CategorySelection = ({ categoryType, handleCategoryTypeChange }) => (
  <FormControl component="fieldset">
    <FormLabel component="legend">Type</FormLabel>
    <RadioGroup
      row
      aria-label="category-type"
      name="category-type"
      value={categoryType}
      onChange={handleCategoryTypeChange}
    >
      <FormControlLabel
        value="category"
        control={<Radio />}
        label="Category"
      />
      <FormControlLabel
        value="sub-category"
        control={<Radio />}
        label="Sub Category"
      />
    </RadioGroup>
  </FormControl>
);

const CategoryFields = ({ editData, handleOnChange }) => (
  <TextField
    fullWidth
    variant="outlined"
    size="small"
    name="name"
    defaultValue={editData.name}
    onChange={(e) => handleOnChange(e, 'name')}
    onInput={(e) => {
      e.target.value = e.target.value.trimStart().replace(/[^a-zA-Z ]*/g, '');
    }}
  />
);

const SubCategoryFields = ({ data, editData, handleOnChange }) => (
  <>
    <CategoryFields editData={editData} handleOnChange={handleOnChange} />
    <InputLabel
      sx={{ fontSize: '16px', color: '#666666', marginTop: '20px' }}
      id="demo-simple-select-label"
    >
      Select Category
    </InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={editData.parent_id}
      name="parent_id"
      fullWidth
      variant="outlined"
      size="small"
      sx={{ fontSize: '1rem !important' }}
      onChange={(e) => handleOnChange(e, 'parent_id')}
    >
      {data?.map((item) => (
        <MenuItem key={item} value={item.id}>
          <ListItemText primary={item.name} />
        </MenuItem>
      ))}
    </Select>
  </>
);

export default function EditFaqCategories(props) {
  const {
    open,
    handleEditClose,
    data,
    handleOnChange,
    editData,
    handleClickEditCategoriesSubmit,
  } = props;

  const [categoryType, setCategoryType] = useState('');

  useEffect(() => {
    setCategoryType(editData.parent_id === 0 ? 'category' : 'sub-category');
  }, [editData]);

  const isCategory = categoryType === 'category';

  const handleCategoryTypeChange = (e) => {
    setCategoryType(e.target.value);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleEditClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" > Edit Categories </DialogTitle>
        <DialogContent>
          <CategorySelection categoryType={categoryType} handleCategoryTypeChange={handleCategoryTypeChange} />
          {isCategory ? (
            <DialogContentText>
              <CategoryFields editData={editData} handleOnChange={handleOnChange} />
            </DialogContentText>
          ) : (
            <SubCategoryFields data={data} editData={editData} handleOnChange={handleOnChange} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            sx={{
              alignSelf: 'center',
              width: '100%',
              
            }}
            disabled={
              isCategory
                ? editData.name === ''
                : editData.name === '' || editData.parent_id === null
            }
            autoFocus
            onClick={handleClickEditCategoriesSubmit}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
